export const IS_CUSTOMIZED_OPTIONS = [
  {
    label: "Yes",
    value: "true"
  },
  {
    label: "No",
    value: "false"
  }
]